class StorageService {
    constructor() {
        this.isLocalStorageAvailable = this.checkLocalStorageAvailability();
        this.memoryStorage = {};
    }

    checkLocalStorageAvailability() {
        try {
            const testKey = '__test__';
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }

    setItem(key, value) {
        if (this.isLocalStorageAvailable) {
            localStorage.setItem(key, value);
        } else {
            this.memoryStorage[key] = value;
        }
    }

    getItem(key) {
        if (this.isLocalStorageAvailable) {
            return localStorage.getItem(key);
        } else {
            return this.memoryStorage[key] || null;
        }
    }

    removeItem(key) {
        if (this.isLocalStorageAvailable) {
            localStorage.removeItem(key);
        } else {
            delete this.memoryStorage[key];
        }
    }

    clear() {
        if (this.isLocalStorageAvailable) {
            localStorage.clear();
        } else {
            this.memoryStorage = {};
        }
    }
}

const storageService = new StorageService();
export default storageService;
